import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import PlatformTabs from "../../Components/EmployersComponents/EMP_overview/PlatformTabs";
import HowItWorks from "../../Components/EmployersComponents/EMP_overview/HowitWorks";
import IntegrationSection from "../../Components/EmployersComponents/EMP_overview/IntegrationSection";
import LogoSection from "../../Components/EmployersComponents/EMP_overview/Emp_companies";
import FormSection from "../../Components/EmployersComponents/EMP_overview/FormSection";


import heroImg from "../../assets/overview_img/hero/overviewhero.webp";
import Footer from "../../Components/Footer";

function EMP_overview() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <section className="w-full bg-white overflow-hidden">
      
      <div className="max-w-[1700px] mx-auto flex flex-col lg:flex-row items-center">

        {/* LEFT CONTENT */}
<div className="w-full lg:w-1/2 px-4 sm:px-8 md:px-14 lg:px-20 pt-4 sm:pt-6 md:pt-10 lg:pt-0 -mt-4 md:-mt-6 lg:-mt-8">
          <p
  className="
    text-[#c4511a]
    font-bold
    uppercase
    tracking-[0.5px]
    lg:tracking-[1px]
    text-[15px]
    sm:text-[18px]
    md:text-[17px]
    lg:text-[14px]
    mt-[140px]
    md:mt-[100px]
    lg:mt-[50px]
    relative
    md:-ml-[20px]
    z-10
  "
>
  PAYMEDAILY PLATFORM
</p>

        <h1
  className="
    text-[#290001]
    font-serif-semi-bold
    tracking-tighter
    lg:tracking-normal

    text-[38px]
    leading-[42px]

    sm:text-[34px]
    sm:leading-[42px]

    md:text-[42px]
    md:leading-[42px]

    lg:text-[44px]
    lg:leading-[54px]

    xl:text-[54px]

    mt-6
    sm:mt-8
    md:-ml-[20px]

    max-w-[680px]
  "
  data-aos="fade-up"
  data-aos-delay="100"
>
  Give Your Workforce <br />
  the Financial <br className="block lg:hidden md:hidden " /> Confidence <br className="hidden lg:block" />
  They Deserve
</h1>

          <p
            className="
              text-[#121111]
              mt-6
              leading-1
              lg:leading-relaxed
              max-w-[700px]
              text-[15px]
              sm:text-[18px]
              md:text-[18px]
              md:text-[#080809]
              lg:text-[16px]
              md:-ml-[18px]

            "
            data-aos="fade-up"
            data-aos-delay="150"
          >
            PayMeDaily is a win-win, giving your team instant access to their earned 
             wages <br className="hidden md:block lg:block" /> and a full suite of financial tools, while giving you the power to 
             better <br className="hidden md:block lg:block" /> engage and reward your workforce.
          </p>

          <button
            className="
              mt-7
              lg:mt-6
              md:-ml-[18px]

              bg-[#290001]
              text-white
              font-semibold
              transition
              hover:bg-orange-500
              px-7 py-3
              lg:px-7 lg:py-3
              text-[15px]
              lg:text-[17px]
            "
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Get a Demo
          </button>
        </div>

        {/* RIGHT IMAGE */}
        <div
          className="
            w-[350px]
            md:w-auto
            md:h-[550px]
            md:overflow-visible
            lg:w-1/2
            ml-[100px]
            lg:ml-0
            relative
            mb-[20px]
            lg:mt-[180px]
            flex
            justify-center
            lg:justify-end

          "
          data-aos="fade-left"
          data-aos-delay="200"
        >
          <img
            src={heroImg}
            alt="hero"
            className="
              w-full
              h-auto
              object-cover
              max-w-[420px]
              sm:max-w-[520px]
              md:max-w-[620px]
              lg:max-w-[700px]
              lg:mb-[10px]
              transform
              lg:translate-x-[60px]
              md:translate-x-[130px]
            "
          />
        </div>
      </div>
      <PlatformTabs />
      <HowItWorks />
      <IntegrationSection />
      <FormSection />
      <LogoSection />

      {/* add here more section */}

      <Footer />
    </section>
  );
}

export default EMP_overview;